// P3 (PM analitik tamamlama, 2026-10-08) — hedef tipleri ve eşik operatörleri: istemci tarafının
// TEK kaynağı (backend: GoalScoreRules.GoalTypes / ThresholdOperators). Hedef editörü, hedef
// şablonları, takım/hedef detayları ve E04 hedef analitiği aynı listeleri kullanır.
export const GOAL_TYPES = ['okr', 'kpi', 'milestone', 'threshold'];
export const THRESHOLD_OPERATORS = ['gte', 'lte', 'eq', 'binary'];
export const OPERATOR_SYMBOL = { gte: '≥', lte: '≤', eq: '=' };

// Koşulun okunur metni: "Gösterge ≥ 5 Adet" / ikili koşulda "Gösterge (Evet/Hayır)".
export const thresholdConditionText = (t, goal) => {
  if (!goal || !goal.thresholdOperator) return '-';
  const name = goal.kpiIndicatorName || '';
  if (goal.thresholdOperator === 'binary') return `${name} (${t('performance.goal.threshold.binaryShort')})`;
  const unit = goal.kpiUnit ? ` ${t(`performance.goal.kpiUnit.${goal.kpiUnit}`, { defaultValue: goal.kpiUnit })}` : '';
  return `${name} ${OPERATOR_SYMBOL[goal.thresholdOperator] || ''} ${goal.thresholdValue ?? '-'}${unit}`.trim();
};
